import { selectedProcessIdAtom } from '../atoms/workspace';
import { AuthenticatedLayout } from '../components/Layout/AuthenticatedLayout';
import { ProcessDetailPanel } from '../components/ProcessDetailPanel/ProcessDetailPanel';
import { trpc } from '../lib/trpc';
import { routes } from '../routes';
import {
  Button,
  Center,
  Container,
  Loader,
  Modal,
  TextInput,
  UnstyledButton,
} from '@mantine/core';
import dayjs from 'dayjs';
import { useAtom } from 'jotai';
import { ArrowLeft, Search } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useLocation } from 'wouter';

export const Archive = () => {
  const [search, setSearch] = useState('');
  const [, navigate] = useLocation();
  const [selectedProcessId, setSelectedProcessId] = useAtom(
    selectedProcessIdAtom,
  );

  useEffect(() => {
    setSelectedProcessId(null);
  }, [setSelectedProcessId]);

  const { data: result, isLoading } = trpc.processes.listArchived.useQuery({
    search: search || undefined,
  });

  const processes = result?.ok ? result.processes : [];

  return (
    <AuthenticatedLayout
      headerRight={
        <Button
          color="gray"
          leftSection={<ArrowLeft size={14} />}
          onClick={() => navigate(routes.home)}
          size="compact-sm"
          variant="subtle"
        >
          Back
        </Button>
      }
    >
      <Container
        className="py-6"
        size="md"
      >
        <h1 className="text-xl font-semibold mb-4">Archive</h1>

        <TextInput
          className="mb-4"
          leftSection={<Search size={15} />}
          onChange={(event) => setSearch(event.currentTarget.value)}
          placeholder="Search archived processes..."
          value={search}
        />

        {isLoading ? (
          <Center className="py-16">
            <Loader
              color="gray"
              size="sm"
            />
          </Center>
        ) : processes.length === 0 ? (
          <Center className="py-16">
            <p className="text-sm text-gray-500 dark:text-gray-400">
              {search
                ? 'No archived processes match your search.'
                : 'No archived processes.'}
            </p>
          </Center>
        ) : (
          <ul className="list-none p-0 m-0 divide-y divide-gray-100 dark:divide-gray-800">
            {processes.map((process) => (
              <li key={process.id}>
                <UnstyledButton
                  className="flex items-center gap-3 px-2 py-3 w-full hover:bg-gray-50 dark:hover:bg-gray-800/50"
                  onClick={() => setSelectedProcessId(process.id)}
                >
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium text-gray-900 dark:text-gray-100 truncate">
                      {process.title}
                    </p>
                    <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                      {process.workspaceTitle} &middot; archived{' '}
                      {dayjs(process.archivedAt).format('MMM D, YYYY')}
                    </p>
                  </div>
                </UnstyledButton>
              </li>
            ))}
          </ul>
        )}
      </Container>
      <Modal
        centered
        onClose={() => setSelectedProcessId(null)}
        opened={Boolean(selectedProcessId)}
        size="70%"
        withCloseButton={false}
      >
        <ProcessDetailPanel />
      </Modal>
    </AuthenticatedLayout>
  );
};
